<template>
  <div>
    <div>
      <div class="d-flex align-items-center mb-2 ml-2">
        <b-form-checkbox id="selecionar-todos"
                         @change="selecionarTodosItens"> 
          <label for="selecionar-todos" 
                 class="mr-4">Selecionar todos os itens
          </label>
        </b-form-checkbox>
        <div class="d-flex align-items-center mb-2 h-25">
          <button class="btn btn-sm btn-default btn-excluir d-flex align-items-center justify-content-between font-weight-bold"
                  type="button"
                  :disabled="!lixeiraHabilitada"
                  @click="excluir($bvModal)">
            <IconSvg class="Excluir-icon icon--sm trash"
                     icon="trash" />
            Excluir
          </button>
        </div>
      </div>
    </div>  
    <table class="w-100">
      <thead :style="color">
        <tr>
          <td class="text-left pl-3">
            Data
          </td>
          <td class="text-left pl-1">
            Tipo de serviço
          </td>
          <td class="text-left pl-5"> 
            Qtd
          </td>
          <td class="text-left pl-2"> 
            Forma de pagamento
          </td>
          <td class="text-left pl-2"> 
            Valor
          </td>
          <td />
        </tr>
      </thead>
      <tbody class="table dados-da-tabela  border-top-0">
        <tr v-for="item in frenteCaixa.pedidos" 
            :key="item.cx_pedido_id">
          <td class="text-left td-dados">
            <b-form-checkbox 
              v-model="item.habilitar"
              @change="checkboxIndividualHabilitado"> 
              <span class="text-left td-dados">
                {{ item.created_at | date }}
              </span>
            </b-form-checkbox>
          </td>
          <td class="text-left td-dados">
            {{ item.tipo_pedido }}
          </td>
          <td class="text-left td-dados pl-5">
            ---
          </td>
          <td class="text-left td-dados">
            <span :id="`recebimento-avulso-tooltip${item.cx_pedido_id}`">
              {{ item.parcelas.length > 1 ? 'Diversas' : item.parcelas[0].forma_pg }}
              <b-badge v-if="item.parcelas.length > 1"
                       variant="light">
                {{ item.parcelas.length }}
              </b-badge>
              <icon-svg v-show="item.parcelas.length > 1"
                        icon="helpCircle"
                        class="icon--sm icon ml-2"
                        style="fill: #074f7f !important;" />
            </span>
            <b-tooltip v-if="item.parcelas.length > 1"
                       :target="`recebimento-avulso-tooltip${item.cx_pedido_id}`"
                       triggers="hover">
              <div v-for="(parcela, index) in item.parcelas"
                   :key="index">
                <div class="d-flex justify-content-between">
                  <span class="mr-1">{{ parcela.forma_pg }}</span>
                  <span>{{ parcela.valor }}</span>
                </div>                  
              </div>
            </b-tooltip>
          </td>
          <td class="text-left td-dados">
            <input id="custa_valor_total_custa"
                   v-money="money"
                   :value="item.valorTotal"
                   disabled
                   class="text-left"
                   :class="{'is-invalid' : errors.has('custa_ipesp')}"
                   name="custa_ipesp"
                   size="10px"
                   trim>
          </td>
          <td class="text-left pt-3 btn-edtar">
            <EditarPagamento v-if="caixaStore.aberto"
                             :prop-pedido="item" />
          </td>
        </tr>
      </tbody>
    </table>
    <ConfirmacaoExclusaoLancamento 
      :prop-itens-habilitados="itensHabilitados" 
      @verificar="verificarExclusaoLancamento" />
    <RemocaoLancamento 
      :atualizar-lancamentos-de-recebimentos="[atualizarLancamentosDeRecebimentos, 'recebimentosAvulsos']" 
      @mensagem="msgTextArea" />
  </div>
</template>

<script>
 //Components

  import RemocaoLancamento from "../../RemocaoLancamento/RemocaoLancamento" 
  import ConfirmacaoExclusaoLancamento from "../../RemocaoLancamento/ConfirmacaoExclusaoLancamento" 
  import EditarPagamento from "../../../FrenteDeCaixaPendentes/EditarPagamento.vue"
  // vuex
  import { mapState } from 'vuex'

  // Imports
  import { VMoney } from 'v-money'
  import  pedidoService from '../../../pedidoService'

  export default {
    name: "TabelaRecebimentosAvulsos",
    directives: {
      money: VMoney
    },
    components: {
      RemocaoLancamento,
      ConfirmacaoExclusaoLancamento,
      EditarPagamento
    },
    data () {
      return {
        color: {
          backgroundColor: "#57bd9c",
        },
        lixeiraHabilitada: false,
        arrayExcluidos: [],
        textoJustificativa: '',
        corfirmarExclusao: false,
        itensHabilitados: [],
        money: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2, 
          masked: false
        },
        filtro: {
          status: 'concluido',
          tipoServico: '',
          data: '',
          numOs: '',
          solicitante: '',
          formaPg: '',
          page: 1,
          perPage: 20,
          lastPage: '',
        },
      }
    }, 
    computed: { 
      ...mapState(['frenteCaixa']),
      cxData () {
        return this.$store.state.frenteCaixa.cxData
      },
      filtroStore () {
        return this.$store.state.frenteCaixa.filtro
      },
      caixaStore () {
        return this.$store.state.frenteCaixa.caixa
      },
    },
    methods: {
      selecionarTodosItens (event) {
        this.frenteCaixa.pedidos.forEach(obj => {
          if (!event) {
            obj.habilitar = false
            this.lixeiraHabilitada = false
            return
          } else if (event &&  this.lixeiraHabilitada ) {
            this.lixeiraHabilitada = false
          }

          obj.habilitar = true
          this.lixeiraHabilitada = true
        })
      },
      checkboxIndividualHabilitado (event) {
        if (event) return this.lixeiraHabilitada = true
        const habilitados =  this.frenteCaixa.pedidos.filter(obj => obj.habilitar)
       
        if (habilitados.length > 1) {
          this.lixeiraHabilitada = true
          
        } else if (habilitados.length == 1 ) {
          this.lixeiraHabilitada = false
          habilitados[0].habilitar = false 
        } 
      },
      async atualizarStatus () {
        this.$store.dispatch('frenteCaixa/atualizarPedidos')
      },
      excluir (mostrarModal) {
        this.itensHabilitados =  this.frenteCaixa.pedidos.filter(obj => obj.habilitar)

        if (!this.corfirmarExclusao) {
          mostrarModal.show('show-modal-confirmacao-lancamento')
        }
       
        if (this.corfirmarExclusao) {
          mostrarModal.show('show-modal-confirmacao')
          this.corfirmarExclusao = false
        }
      },
      atualizarLancamentosDeRecebimentos () {
        this.atualizarStatus ()
        this.arrayExcluidos = []
        this.lixeiraHabilitada = false
        this.textoJustificativa = ''
        this.itensHabilitados = []
      },
      async msgTextArea (texto) {
        try {
          this.textoJustificativa = texto
          this.frenteCaixa.pedidos.forEach( item => item.habilitar && this.arrayExcluidos.push(item.cx_pedido_id))
          await pedidoService.excluirRecebimentosAvulsos({arrayExcluidos: this.arrayExcluidos, msg: this.textoJustificativa })
          
          setTimeout (() => {
            this.mensagemDeExclusao()
          }, 2000)
          this.atualizarLancamentosDeRecebimentos()
        } catch (error) {
          const message = getErrors(error)
          displayMessage('error', 'Erro!', message.message)
        }
      },
      mensagemDeExclusao () {
        objSwal.success.title = this.arrayExcluidos.length ? this.arrayExcluidos.length  > 1 ? `Pedidos excluídos com sucesso.` : `Pedido excluído com sucesso.` : ''
        Swal.fire(objSwal.success)  
      },
      verificarExclusaoLancamento (modal) {
        this.corfirmarExclusao = true
        this.excluir(modal)
      }
    }
  }
</script>

<style scoped>
    .trash {
      width:15px;
    }
    .btn-excluir {
      cursor:pointer;
      font-size: 1.2rem;
      width: 100px;
    }
    thead {
      border-right: 1.5px solid #57bd9c;
      border-left: 1px solid #57bd9c;
      font-size:1.2rem;
      font-weight: bolder;
    }
    .dados-da-tabela {
      border: 0.5px solid #C6C6C6;   
    }
    tbody tr {
      border-top: 0.5px solid #C6C6C6;
    }
    tbody tr:hover {
      background-color:#f5f5f5;
      cursor:pointer;
    }
    td {
      width: 16%;
      padding-top: 10px;
      padding-bottom: 10px;
    }
    .td-dados {
      padding-top: 25px;
      padding-bottom: 25px;
    }
    .btn-edtar {
      display: flex;
      justify-content: flex-start;
    }
</style>
